import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../API/Main/API';
import { ClientInsuranceDataProperties } from '../../API/ClientAPIHelpers/clientInsuranceProperties';
import { ErrorProperties } from '../../API/identityAPIProperties';
import { SoapNotesFullProperties } from '../../API/ClientAPIHelpers/soapNoteProperties';

interface ClientInsuranceStateProperties {
	error: ErrorProperties;

	loading: boolean;
	soapNotes: SoapNotesFullProperties[];
}

const initialClientInsuranceState: ClientInsuranceStateProperties = {
	loading: false,
	soapNotes: [],
	error: {
		status: 0,
		title: '',
	},
};

export const getInsuranceList = createAsyncThunk(
	'/client/clients/list',
	async (data: ClientInsuranceDataProperties, thunkAPI) => {
		const response = await API.ClientAPI.ClientInsurance.getInsurances(data);

		if (response.error) {
			return thunkAPI.rejectWithValue(response.error);
		}

		return response as SoapNotesFullProperties[];
	},
);

export const updateInsurance = createAsyncThunk(
	'/client/clients/insurance/update/backdate',
	async (data: ClientInsuranceDataProperties, thunkAPI) => {
		const response = await API.ClientAPI.ClientInsurance.updateInsurance(data);

		if (response.error) {
			return thunkAPI.rejectWithValue(response.error);
		}

		return response;
	},
);

const clientInsuranceSlice = createSlice({
	name: 'clientInsurance',
	initialState: initialClientInsuranceState,
	reducers: {
		clearNotes(state) {
			state.soapNotes = initialClientInsuranceState.soapNotes;
		},
	},
	extraReducers: (builder) => {
		// getInsuranceList
		builder.addCase(getInsuranceList.pending, (state) => {
			state.loading = true;
			state.error = initialClientInsuranceState.error;
		});
		builder.addCase(getInsuranceList.fulfilled, (state, action) => {
			state.loading = false;
			state.soapNotes = action.payload;
		});
		builder.addCase(getInsuranceList.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload as ErrorProperties;
		});
	},
});

export const { clearNotes } = clientInsuranceSlice.actions;
export default clientInsuranceSlice.reducer;
